
	import {
		Message
	} from "element-ui";
	import utils from "@/utils";
	import Sortable from "sortablejs";
	import triggerMethods from "@/store/triggerMethods";
	import {
		Component,
		Vue,
		Provide,
		Watch
	} from "vue-property-decorator";
	import Menu, {
		inEnum,
		MenuIcon,
		numberEnum
	} from "@/model/MenuEnum";
	import DataHelperSingleton from "@/store/DataHelperSingleton";
		import FileSaver from 'file-saver';
		import XLSX from 'xlsx';

	@Component
	export default class Welcome extends Vue {
		$router: any;
		$message: any;
		$Menu: any;
		$store: any;
		element: any;
		$confirm: any;
		$refs: any;
		@Provide() tabelHeight: number = window.innerHeight;
		@Provide() sortable: any = "";
		@Provide() isRouterAlive: any = true;
		@Provide() activeIndex: string | null = "1";
		@Provide() dialogVisible = false;
		@Provide() dialogVisible2 = false;
		@Provide() dialogVisible3 = false;
		@Provide() backAllColFlag = false;
		@Provide() list: any = [];
		@Provide() valueList: any = [];
		@Provide() col: any = this.$store.state.col;
		@Provide() shaixuancol: any = [];
		@Provide() Col1: any = this.$store.state.Col1;
		@Provide() Col2: any = this.$store.state.Col2;
		@Provide() dropCol: any = this.$store.state.dropCol;
		@Provide() dropCol1: any = this.$store.state.dropCol1;
		@Provide() dropCol2: any = this.$store.state.dropCol2;
		@Provide() name = "";
		@Provide() cid = 0;
		@Provide() classFastln = ""; //实际进入时间
		@Provide() classLastOut = ""; //实际离开时间

		@Provide() valueTime: any = [];

		@Provide() teacherList: any = [];
		@Provide() courseList: any = [];
		@Provide() courseKey: any = 0;
		@Provide() sumTimes = "0";
		@Provide() sumUSDPay = "0";
		@Provide() sumCNYPay = "0";
		@Provide() this = this;

		@Provide() teacherName: any = []; //导师筛选名称
		@Provide() courseName: any = []; //课程筛选名称
		@Provide() headMaster: any = []; //班主任筛选名称
		@Provide() isFreeOption: Array < object > = [{
				name: "赠送课节",
				value: 1
			},
			{
				name: "正常课节",
				value: 0
			},
		]; //赠课类型筛选名称
		@Provide() isFreeValue: string = ""; //赠课类型值
		@Provide() value = ""; //导师筛选值
		@Provide() coursevalue = ""; //课程筛选值
		@Provide() headMasterValue = ""; //班主任筛选值
		@Provide() queryInfo: any = {
			query: "",
			pageNum: 1, //当前页
			pageSize: parseInt((((window.innerHeight - 316) / 50) - 1).toString()), //当前每页显示多少条
		};
		@Provide() total = 0; //页面中数据总条数
		@Provide() switchValue = true; //时区
		@Provide() switchOpenValue = false; //公开课
		@Provide() switchFreeValue = false; //赠送课程
		@Provide() stringOrderBy = "25 DESC"; //主页排序
		@Provide() StringMergeTeacherOrderBy = "1"; //导师排序
		@Provide() StringMergeCourseOrderBy = "null "; //课程排序
		@Provide() sumvalueUSD ? : string = "0"; //合计美元
		@Provide() sumvalueCNY ? : string = "0"; //合计人民币
		@Provide() sumScore ? : string = "0"; //合计分值
		@Provide() actualDuration ? : string | number = 0; //合计总时长
		@Provide() billDuration ? : string | number = 0; //合计总计费时长
		@Provide() MenuFor: any; //菜单栏
		@Provide() editInfoForm = { // 课节基本数据修改信息
			id: 0,
			name: "",
			switchValue: true,
			classFastln: "",
			classLastOut: "",
			classRate: 0, //时薪
			rateType: "美元", //时薪类型
			billDuration: 0, //计费时长
			switchOpenValue: false, //公开课
			switchFreeValue: false, //赠送课
		}; //编辑信息    时间   时薪  时薪类型
		@Provide() HoursAndContractForm = {
			id: 0,
			courseName: "",
			totalDuration: 0,
			leftDuration: 0,
			serviceStateId: 1,
		};
		@Provide() dialog3Form = { //学员课程邮箱修改信息
			id: 0,
			courseName: "",
			email: "",
		};
		@Provide() totalDurationRadio = "1"; //总课时
		@Provide() triggerMethodPro = triggerMethods.$on("trigger", () => {
			this.selectClassInfos();
		}); //触发刷新数据
		@Provide() EditClassFastln ? : string | number | undefined = "";
		@Provide() EditClassFastlnDFW ? : string | number | undefined = "";
		@Provide() EditClassLastOut ? : string | number | undefined = "";
		@Provide() EditClassLastOutDFW ? : string | number | undefined = "";

		@Provide() serviceStateOptions: Array < object > = []; //服务状态选项
		@Provide() serviceState: Array < number > = [1, 2]; //服务状态选项值
		@Provide() serviceStateOptionsEdit: Array < any > = [{
			label: "服务中",
			value: 1
		}]; //服务状态选项编辑
		@Provide() serviceStateEdit: number = 1; //服务状态选项值编辑
		@Provide() openClassFlag: boolean = false; //公开课
		@Provide() delHeight = 316; //table前头高度
		@Provide() showSearch = true; //搜索区域变量标识
		@Provide() updateEmailDisabled = false; //学生邮箱弹窗显示变量
		@Provide() MergeCourseReminders: any = []; //学员课程平均月预算报警
		@Provide() classInfoList: any = [];
		@Provide() teacherLists: any = [];
		@Provide() courseLists: any = [];
		
		@Provide() classRateDialog = false;
		@Provide() classRateTypes = 0;
		@Provide() classRateDetail = {};

		//监听搜索区域变量是否变化
		@Watch("showSearch")
		watchShowSearch(val: any, oldVal: any): void {
			if (val) {
				this.delHeight = 316; //当显示搜索区域时，表格的位置将随delHeight变量下移
				this.queryInfo.pageSize = parseInt((((window.innerHeight - 316) / 50) - 1).toString()) //当前每页显示多少条
			} else {
				this.delHeight = 203; //当隐藏搜索区域时，表格的位置将随delHeight变量上移
				this.queryInfo.pageSize = parseInt((((window.innerHeight - 203) / 50) - 1).toString()) //当前每页显示多少条
			}
			//进入菜单标签后加载相应数据
			this.enterTheLabelMenuToLoadData();
		}

		//监听菜单变化
		@Watch("activeIndex")
		watchActiveIndex(val: any, oldVal: any): void {
			//将 活动索引 (1=课节信息,2=导师汇总,3=学员课程) 记录至local storage
			localStorage.setItem("WelcomeIndex", val);
		}
		
		queryDetailRate(detail,types){
			utils.requestGet("查询课节评分详情", "infos/getRateDetails", {
				types:types,
				id:types == 1?detail.cid.id:detail.id
			})
			.then((data: any) => {
				this.classRateDialog = true;
				for(let i=0;i<data.length;i++){
					data[i].details = JSON.parse(data[i].details);
				}
				this.classRateDetail = data;
				this.classRateTypes = types;
			})
		}
		
		changeState(e){
			if(!e){
				this.changeCourse();
			}
		}
		
		exportExcel () {
					this.$confirm('导出信息为当前条件筛选的结果，确定导出为EXCEL吗？（根据数据量，导出时间会加长）', '提示', {
					          confirmButtonText: '确定',
					          cancelButtonText: '取消',
					          type: 'success'
					        }).then(() => {
								if(this.activeIndex == "1"){
								utils.requestPost("查询主页课节信息", "infos/selectAllInfos", {
										searchSelectDate: {
											classStartName: this.valueTime != null && this.valueTime.length > 0 ?
												this.valueTime[0] : "",
											classEndName: this.valueTime != null && this.valueTime.length > 0 ?
												this.valueTime[1] : "",
											switchDate: this.switchValue,
										},
										page: {
											pageNum: this.queryInfo.pageNum,
											pageSize: this.queryInfo.pageSize,
										},
										stringOrderBy: this.stringOrderBy,
										teacherName: this.value,
										courseName: String(this.coursevalue),
										headmaster: String(this.headMasterValue),
										isFree: String(this.isFreeValue),
										isPublic: Boolean(this.openClassFlag),
										serviceState: String(this.serviceState),
										email: utils.getAccountEmail(),
										name: utils.getAccountName(),
									})
									.then((data: any) => {
										const dataList = data.classInfos.data;
										for (let i = 0; i < dataList.length; i++) {
											try{
												dataList[i].cid.salaryUSD = parseFloat(dataList[i].cid.salaryUSD).toFixed(2);
												dataList[i].cid.salaryCNY = parseFloat(dataList[i].cid.salaryCNY).toFixed(2);
											}catch(e){
												
											}
											if (dataList[i].coid.totalDuration == -1) {
												dataList[i].coid.totalDuration = "+ ∞";
												dataList[i].coid.leftDuration = "+ ∞";
											}
											//当为公开课时，服务状态设置为空
											if (dataList[i].cid.isPublic == true) {
												dataList[i].serviceState.serviceStateName = "";
											}
										}
										//课节信息
										this.classInfoList = dataList;
										this.$message({
										  showClose: true,
										  message: '处理完成，即将导出EXCEL',
										  type: 'success',
										  duration:2000
										});
										setTimeout(function () {
											/* generate workbook object from table */
											let wb = XLSX.utils.table_to_book(document.querySelector('#classInfosExcel'));
											/* get binary string as output */
											let widths = [];
											for(let i=0;i<35;i++){
												widths.push({t:"s",wpx: 120});
											}
											wb.Sheets.Sheet1['!cols'] = widths;
											let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
											try {
												FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '课节信息.xlsx');
											} catch (e)
											{
												if (typeof console !== 'undefined')
													console.log(e, wbout)
											}
											return wbout;
										}, 2000);
								});
								}
								if(this.activeIndex == "2"){
									
									
									var str = "";
									str+="<tr>";
									for(let i=0;i<this.dropCol1.length;i++){
										str+="<td>"+this.dropCol1[i].label+"</td>";
									}
									str+="</tr>";
									
									
									
									utils.getUSDExchangeRate().then((rate: any) => {
										utils
											.requestPost("查询导师汇总", "teacher/MergeteacherAllInfos", {
												searchSelectDate: {
													classStartName: this.valueTime != null && this.valueTime.length > 0 ?
														this.valueTime[0] : "",
													classEndName: this.valueTime != null && this.valueTime.length > 0 ?
														this.valueTime[1] : "",
													switchDate: this.switchValue,
												},
												page: {
													pageNum: this.queryInfo.pageNum,
													pageSize: this.queryInfo.pageSize,
												},
												stringOrderBy: this.StringMergeTeacherOrderBy,
												teacherName: this.value,
												courseName: String(this.coursevalue),
												headmaster: String(this.headMasterValue),
												rate: rate,
												isPublic: Boolean(this.openClassFlag),
											})
											.then((data: any) => {
												let teacherList = [];
												for (var i = 0; i < data.mergeTeacher.mergeTeacher.length; i++) {
													teacherList.push({
														teacherName: data.mergeTeacher.mergeTeacher[i].teacherName,
														types: data.mergeTeacher.mergeTeacher[i].types,
														times: Number(data.mergeTeacher.mergeTeacher[i].classActualDuration)
															.toFixed(2),
														price: data.mergeTeacher.mergeTeacher[i].teacherRate,
														payrateUSD:
															Number(
																data.mergeTeacher.mergeTeacher[i].salaryUSD
															).toFixed(2),
														payrateCNY: 
															Number(
																data.mergeTeacher.mergeTeacher[i].salaryCNY
															).toFixed(2),
														xinxi: data.mergeTeacher.mergeTeacher[i].userInformation.toString(),
														fukuanfangshi: data.mergeTeacher.mergeTeacher[i].teacherPay,
														name: data.mergeTeacher.mergeTeacher[i].userName,
														billDuration: data.mergeTeacher.mergeTeacher[i].billDuration,
														identity: data.mergeTeacher.mergeTeacher[i].identity.toString(),
														phone: data.mergeTeacher.mergeTeacher[i].phone
													});
												}
												//导师汇总信息
												this.teacherLists = teacherList;
												
												for(let t=0;t<this.teacherLists.length;t++){
													str+="<tr>";
													for(let i=0;i<this.dropCol1.length;i++){
														if(this.dropCol1[i].label == "导师"){
															str+="<td>"+this.teacherLists[t].teacherName+"</td>";
														}
														if(this.dropCol1[i].label == "时薪类型"){
															str+="<td>"+this.teacherLists[t].types+"</td>";
														}
														if(this.dropCol1[i].label == "时薪"){
															str+="<td>"+this.teacherLists[t].price+"</td>";
														}
														if(this.dropCol1[i].label == "计费时长"){
															str+="<td>"+this.teacherLists[t].billDuration+"</td>";
														}
														if(this.dropCol1[i].label == "实际时长"){
															str+="<td>"+this.teacherLists[t].times+"</td>";
														}
														if(this.dropCol1[i].label == "美元额度"){
															str+="<td>"+this.teacherLists[t].payrateUSD+"</td>";
														}
														if(this.dropCol1[i].label == "人民币额度"){
															str+="<td>"+this.teacherLists[t].payrateCNY+"</td>";
														}
														if(this.dropCol1[i].label == "付款方式"){
															str+="<td>"+this.teacherLists[t].fukuanfangshi+"</td>";
														}
														if(this.dropCol1[i].label == "账号信息"){
															str+="<td>"+this.teacherLists[t].xinxi+"</td>";
														}
														if(this.dropCol1[i].label == "账号姓名"){
															str+="<td>"+this.teacherLists[t].name+"</td>";
														}
														if(this.dropCol1[i].label == "证件信息"){
															str+="<td>"+this.teacherLists[t].identity+"</td>";
															
														}
														if(this.dropCol1[i].label == "签约电话"){
															str+="<td>"+this.teacherLists[t].phone+"</td>";
														}
													}
													str+="</tr>";
												} 
												document.getElementById("teacherExcel").innerHTML = str;
												
												
												this.$message({
												  showClose: true,
												  message: '处理完成，即将导出EXCEL',
												  type: 'success',
												  duration:2000
												});
												setTimeout(function () {
													let xlsxParam = {raw:true};
													/* generate workbook object from table */
													let wb = XLSX.utils.table_to_book(document.querySelector('#teacherExcel'),xlsxParam);
													/* get binary string as output */
													let widths = [];
													for(let i=0;i<35;i++){
														widths.push({wpx: 120});
													}
													wb.Sheets.Sheet1['!cols'] = widths;
													let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
													try {
														FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '导师汇总.xlsx');
													} catch (e)
													{
														if (typeof console !== 'undefined')
															console.log(e, wbout)
													}
													return wbout;
												}, 2000);
											});
									});
								}
								if(this.activeIndex == "3"){
									//查询学员课程信息
									utils
										.requestPost("查询学员课程", "course/MergeCourseAllInfos", {
											searchSelectDate: {
												classStartName: this.valueTime != null && this.valueTime.length > 0 ?
													this.valueTime[0] : "",
												classEndName: this.valueTime != null && this.valueTime.length > 0 ?
													this.valueTime[1] : "",
												switchDate: this.switchValue,
											},
											page: {
												pageNum: this.queryInfo.pageNum,
												pageSize: this.queryInfo.pageSize,
											},
											stringOrderBy: this.StringMergeCourseOrderBy,
											teacherName: this.value,
											courseName: String(this.coursevalue),
											headmaster: String(this.headMasterValue),
											isFree: String(this.isFreeValue),
											isPublic: Boolean(this.openClassFlag),
											serviceState: String(this.serviceState),
											email: utils.getAccountEmail(),
											name: utils.getAccountName(),
										})
										.then((data: any) => {
											let courseList = [];
											for (let i = 0; i < data.studentInfo.mergeCourse.length; i++) {
												console.log(data.studentInfo.mergeCourse[i].avgRate)
												let studentHeadmaster = "";
												courseList.push({
													id: data.studentInfo.mergeCourse[i].id,
													courseName: data.studentInfo.mergeCourse[i].courseName,
													times: Number(data.studentInfo.mergeCourse[i].actualDuration).toFixed(2),
													studentHeadmaster: data.studentInfo.mergeCourse[i].studentHeadmaster,
													billDuration: Number(data.studentInfo.mergeCourse[i].billDuration).toFixed(2),
													email: data.studentInfo.mergeCourse[i].email,
													serviceStateName: data.studentInfo.mergeCourse[i].serviceStateName,
													contractStartTime: data.studentInfo.mergeCourse[i].contractStartTime,
													contractEndTime: data.studentInfo.mergeCourse[i].contractEndTime,
													contractDiffDate: data.studentInfo.mergeCourse[i].contractDiffDate,
													averageMonthlyBudget: data.studentInfo.mergeCourse[i].averageMonthlyBudget,
													averageMonthlyBudgetUSD: data.studentInfo.mergeCourse[i].averageMonthlyBudgetUSD,
													actualAverageMonthlyCost:  data.studentInfo.mergeCourse[i].actualAverageMonthlyCost,
													actualAverageMonthlyCostUSD: data.studentInfo.mergeCourse[i].actualAverageMonthlyCostUSD,
													sumUSD: Number(data.studentInfo.mergeCourse[i].salaryUSD).toFixed(2),
													sumCNY: Number(data.studentInfo.mergeCourse[i].salaryCNY).toFixed(2),
													totalDuration: utils.convertHours(data.studentInfo.mergeCourse[i].totalDuration),
													leftDuration: utils.convertHours(data.studentInfo.mergeCourse[i].leftDuration),
									
													remainingbudgetUSD: data.studentInfo.mergeCourse[i].remainingbudgetUSD,
													remainingbudgetCNY: data.studentInfo.mergeCourse[i].remainingbudgetCNY,
									
													remainingbudgetPercentages: data.studentInfo.mergeCourse[i].remainingbudgetPercentages == 99999? "-∞ %" : (data.studentInfo.mergeCourse[i].remainingbudgetPercentages * 100) + "%",
													
													cnyMoney: data.studentInfo.mergeCourse[i].cnyMoney,
													usdMoney: data.studentInfo.mergeCourse[i].usdMoney,
													state: data.studentInfo.mergeCourse[i].state == 0 ? '历史信息': data.studentInfo.mergeCourse[i].state == 1 ? '进行中':data.studentInfo.mergeCourse[i].state == 2?'已结束':'',
													ifRate: data.studentInfo.mergeCourse[i].ifRate == 1 ? '未评价':(data.studentInfo.mergeCourse[i].avgRate.toFixed(2)),
													minRate: data.studentInfo.mergeCourse[i].minRate,
													overflow: data.studentInfo.mergeCourse[i].overflow,
													score: data.studentInfo.mergeCourse[i].score,
													courseEndTime: data.studentInfo.mergeCourse[i].courseEndTime,
													submissionTime: data.studentInfo.mergeCourse[i].submissionTime,
												});
											}
											//学员课节信息
											this.courseLists = courseList;
											this.$message({
											  showClose: true,
											  message: '处理完成，即将导出EXCEL',
											  type: 'success',
											  duration:2000
											});
											setTimeout(function () {
												/* generate workbook object from table */
												let wb = XLSX.utils.table_to_book(document.querySelector('#courseExcel'));
												/* get binary string as output */
												let widths = [];
												for(let i=0;i<35;i++){
													widths.push({t:"s",wpx: 120});
												}
												wb.Sheets.Sheet1['!cols'] = widths;
												let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
												try {
													FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '学员课程.xlsx');
												} catch (e)
												{
													if (typeof console !== 'undefined')
														console.log(e, wbout)
												}
												return wbout;
											}, 2000);
										});
								}
					  }).catch(() => {});
				 }

		/**
		 * @description: 对于导师，学员课程，班主任和服务状态等进行筛选渲染数据
		 * @param {boolean} event
		 * @param {string} str '筛选名'
		 * @param {string} label '筛选标签'
		 * @return void
		 */
		selectMethods(event: boolean, str: string, label: string): void {
			//if(event&&this.$refs[label].emptyText!=null){
			switch (str) {
				case 'teacher': {
					// this.selectTeacherOptions();
					break;
				}
				case 'course': {
					//this.selectCourseNameOptions();
					break;
				}
				case 'headMaster': {
					// this.selectHeadMasterOptions();
					break;
				}
				case 'serviceState': {
					this.selectServiceStateOptions();
					break;
				}
				default:
					break;
			}
			//}
		}

		/**
		* @description: 颜色筛选 (对于查询出来的学员课程平均月预算进行判断条件显示对应颜色提示)
		* ( 实际平均月消费 / 平均月预算) * 100% (颜色差异需考虑优先级)  =  平均月预算溢出颜色
		    当百分比>100% 为红色
		    当百分比>75% 为橙色
		    当百分比>50% 为黄色
		    其他为绿色
		* @param {any} item
		* @return void
		*/
		checkMergeCourseReminders(item: any) {
			if (item.overflow > 1) {
				return "background:#F56C6C;";
			} else if (item.overflow > 0.75) {
				return "background:#E6A23C;";
			} else if (item.overflow > 0.5) {
				return "background:#ffea01;";
			}
			//当平均月预算为0，但是平均月消费不为0时，则为红色
			if(item.averageMonthlyBudget == "￥ 0.00" && item.actualAverageMonthlyCost != "￥ 0.00"){
				return "background:#F56C6C;";
			}else{
				return "background:#67C23A;";
			}
			
		}
		/**
		 * @description: 全屏浏览功能
		 * @return void / 有返回信息 {返回类型} 描述信息
		 */
		isDocumentInFullScreenMode() {
			//获取dom
			const dom = document.getElementById("classInfos");
			//不为空则全屏浏览
			if (dom != null) dom.requestFullscreen();
		}

		/**
		 * @description: 横向tab标签页面 切换tab功能  
		 * @param {any} element自带钩子参数 key ：(1=>【课节信息】,2=>【导师汇总】 和 3=>【学员课程】)
		 * @return void
		 */
		handleSelect(key: any, keyPath: any): void {
			/**
			 * 该(activeIndex)变量监听如果值改变，将触发watch将活动tab索引进行存储至localstorage中
			 * 目的是：下次登录平台默认进行activeIndex对于的tab标签页面
			 */
			this.activeIndex = key; //活动栏
			/**
			 * 该(queryInfo.pageNum)变量对于切换页面时，分页功能num进行重置
			 */
			this.queryInfo.pageNum = 1; //设置默认

			// if (key == 1) {
			// 	this.selectClassInfos(); //渲染数据  【课节信息】
			// }
			// if (key == 2) {
			// 	this.Mergeteacher(); //渲染数据  【导师汇总】
			// }
			// if (key == 3) {
			// 	this.MergeCourse(); //渲染数据  【学员课程】
			// }

			this.TotalSalary(); //汇总信息  ：计费时长   ：实际时长  ： 薪水
		}

		/**
		 * @description: 在基础信息修改弹窗中 时区(PEK)和(DFW)相互切换 switch触发改变数据("实际进入"和"实际离开")
		 * @param {null} null
		 * @return void
		 */
		triggerChangeTime(): void {
			//当switch为flase时，"实际进入"时间为PEK，否则为DFW
			this.editInfoForm.classFastln =
				this.switchValue == false ?
				String(this.EditClassFastln) :
				String(this.EditClassFastlnDFW);
			//当switch为flase时，"实际离开"时间为PEK，否则为DFW
			this.editInfoForm.classLastOut =
				this.switchValue == false ?
				String(this.EditClassLastOut) :
				String(this.EditClassLastOutDFW);
		}

		/**
		 * @description: 基础信息修改弹窗
		 * @param {any} e (课节信息表中的行信息)
		 * @return void
		 */
		basicInformationPopUpInformation(e: any) {
			/* 当修改课节基础信息时，处于全屏状态，则退出 */
			if (document.fullscreenElement) {
				document.exitFullscreen();
			} else if ((document as any).mozCancelFullScreen) {
				(document as any).mozCancelFullScreen();
			} else if ((document as any).webkitExitFullscreen) {
				(document as any).webkitExitFullscreen();
			} else if ((document as any).msExitFullscreen) {
				(document as any).msExitFullscreen();
			}
			// 提取表格中行row中的信息
			const {
				cid: {
					id,
					classFastln,
					classFastlnDFW,
					classLastOut,
					classLastOutDFW,
					classRate,
					types,
					billDuration,
					isPublic,
					isFree,
				},
				coid: {
					courseName,
					email
				},
			} = e;
			this.EditClassFastln = classFastln;
			this.EditClassFastlnDFW = classFastlnDFW;
			this.EditClassLastOut = classLastOut;
			this.EditClassLastOutDFW = classLastOutDFW;
			this.editInfoForm.id = id;
			this.editInfoForm.name = courseName;
			this.editInfoForm.classFastln =
				this.switchValue == false ? classFastln : classFastlnDFW;
			this.editInfoForm.classLastOut =
				this.switchValue == false ? classLastOut : classLastOutDFW;
			this.editInfoForm.classRate = classRate;
			this.editInfoForm.billDuration = billDuration;
			this.editInfoForm.rateType = types === "USD" ? "美元" : "人民币";
			this.switchOpenValue = isPublic;
			this.switchFreeValue = isFree;
			//将弹窗变量赋值为true显示
			this.dialogVisible2 = true;
		}

		/**
		 * @description: 在课节信息中 对于table column的fieldName进行对应过滤 order by 字段排序
		 * @param {string} name
		 * @return void
		 */
		switchfield(name: string) {
			switch (name) {
				case "cid.ifRate": //1
					return "43";
				case "cid.classStartName": //1
					return "25";
				case "tid.teacherName": //1
					return "10";
				case "coid.courseName": //1
					return "6";
				case "tid.teacherPay": //1
					return "11";
				case "cid.classRate": //1
					return "23";
				case "cid.types": //1
					return "22";
				case "tid.userName": //1
					return "12";
				case "tid.userInformation": //1
					return "13";
				case "sid.studentPhone": //1
					return "19";
				case "sid.studentHeadmaster": //1
					return "20";
				case "sid.studentHeadmasterPhone": //1
					return "21";
				case "cid.className": //1
					return "24";
				case "cid.classEndName": //1
					return "26";
				case "cid.classActualDuration": //1
					return "29";
				case "cid.classFastln": //1
					return "32";
				case "cid.classLastOut": //1
					return "33";
				case "cid.classStartNameDFW": //
					return "25";
				case "cid.id": //1
					return "4";
				case "cid.salaryUSD": //1
					return "1";
				case "cid.salaryCNY": //1
					return "1";
				case "cid.classEndNameDFW": //
					return "26";
				case "cid.classFastlnDFW": //
					return "32";
				case "cid.classLastOutDFW": //
					return "33";
				case "cid.billDuration": //1
					return "34";
				case "coid.totalDuration": //1
					return "7";
				case "coid.leftDuration": //1
					return "8";
				case "coid.email": //1
					return "9";
				case "cid.isFree": //1
					return "35";
				case "cid.isPublic": //1
					return "36";
				case "serviceState.serviceStateId": //1
					return "38";
				case "serviceState.serviceStateName": //1
					return "37";
				case "cid.state": //1
					return "41";
				case "cid.avgRate": //1
					return "42";
				default:
					return "2";
			}
		}

		/**
		 * @description: 在导师汇总中 对于table column的fieldName进行对应过滤 order by 字段排序
		 * @param {string} name
		 * @return void
		 */
		switchMergeteacherfield(name: string) {
			switch (name) {
				case "teacherName":
					return "2";
				case "types":
					return "3";
				case "price":
					return "4";
				case "times":
					return "9";
				case "payrateUSD":
					return "11";
				case "payrateCNY":
					return "11";
				case "fukuanfangshi":
					return "5";
				case "xinxi":
					return "7";
				case "name":
					return "6";
				case "billDuration":
					return "12";
				case "identity":
					return "13";
				case "phone":
					return "14";
				default:
					return "1";
			}
		}
		/**
		 * @description: 在学员课程中 对于table column的fieldName进行对应过滤 order by 字段排序
		 * @param {string} name
		 * @return void
		 */
		switchMergecoursefield(name: string) {
			switch (name) {
				case "id":
					return "1";
				case "courseName":
					return "2";
				case "times":
					return "3";
				case "billDuration":
					return "4";
				case "sumUSD":
					return "5";
				case "sumCNY":
					return "6";
				case "totalDuration":
					return "7";
				case "leftDuration":
					return "8";
				case "studentHeadmaster":
					return "9";
				case "studentHeadmasterPhone":
					return "10";
				case "email":
					return "11";
				case "serviceStateName":
					return "12";
				case "contractStartTime":
					return "13";
				case "contractEndTime":
					return "14";
				case "contractDiffDate":
					return "15";
				case "averageMonthlyBudgetUSD":
					return "16";
				case "averageMonthlyBudget":
					return "17";
				case "actualAverageMonthlyCost":
					return "18";
				case "actualAverageMonthlyCostUSD":
					return "19";
				case "remainingbudgetUSD":
					return "20";
				case "remainingbudgetCNY":
					return "21";
				case "remainingbudgetPercentages":
					return "22";
				case "usdMoney":
					return "23";
				case "cnyMoney":
					return "24";
				case "state":
					return "25";
				case "ifRate":
					return "26";
				case "avgRate":
					return "27";
				case "minRate":
					return "28";
				case "score":
					return "30";
				case "courseEndTime":
					return "31";	
				case "submissionTime":
					return "32";	
				default:
					return "1";
			}
		}

		/**
		 * @description: 学员课程中的行信息跳转至新窗口
		 * @param {any} row 学员课程中的行对象数据
		 * @param {any} column 列信息
		 * @param {any} event //时间
		 * @return void
		 */
		rowClickJumpPage(row: any, column: any, event: any) {
			//页面跳转至新窗口并携带参数 主键
			let path = "/CourseInformationOperation/" + row.id;
			let link = this.$router.resolve({
				path: path, //要跳转的路由
			});
			window.open(link.href, "_blank"); //打开新窗口
		}

		/**
		 * @description: 公开课和赠送课格式转换
		 * @param {object} row 学员课节中的行对象数据信息
		 * @param {any} column 列信息
		 * @param {any} cellValue 单元格信息
		 * @return void
		 */
		formatter(row: object, column: any, cellValue: any) {
			if (column.property === "cid.isFree")
				return cellValue == false ? "正常课节" : "赠送课节";
			if (column.property === "cid.isPublic")
				return cellValue == false ? "非公开课" : "公开课";
			if (column.property === "cid.state")
				return cellValue == 0 ? '历史信息':cellValue == 1 ? '待上课':cellValue == 2?'已结束':'';
			if (column.property === "cid.ifRate"){
				return cellValue == 1 ? '未评价':(row.cid.avgRate.toFixed(2))
			}
				
			return cellValue;
		}

		/**
		 * @description: 分页功能中 当尺寸改变时触发该方法
		 * @param {any} val
		 * @return void
		 */
		handleSizeChange(val: any) {
			this.queryInfo.pageSize = val; //监听page改变的页数
			if (this.activeIndex === "2") {
				this.Mergeteacher(); //当活动索引是导师汇总时，渲染导师信息
			} else if (this.activeIndex === "3") {
				this.MergeCourse(); //当活动索引时学员课程时，渲染学员课程信息
			} else {
				this.selectClassInfos(); //渲染学员课节信息
			}
		}

		/**
		 * @description: 分页功能中 当"当前页"改变时触发该方法
		 * @param {any} val
		 * @return void
		 */
		handleCurrentChange(val: any) {
			this.queryInfo.pageNum = val; //监听页面值改变的事件
			if (this.activeIndex === "2") {
				this.Mergeteacher(); //当活动索引是导师汇总时，渲染导师信息
			} else if (this.activeIndex === "3") {
				this.MergeCourse(); //当活动索引时学员课程时，渲染学员课程信息
			} else {
				this.selectClassInfos(); //渲染学员课节信息
			}
		}

		/**
		 * @description: 课节信息table中自定义排序方法
		 * @param {any} column 课节信息中的列信息
		 * @param {any} key 
		 * @param {any} order (升序/排序)
		 * @return void
		 */
		sortChange(column: any, key: any, order: any) {
			//获取字段名称和排序类型
			var fieldName = column.column.labelClassName; //1.可以使用 var fieldName = column.column.label;   //"导师"
			var sortingType = column.order;
			var StringName = this.switchfield(fieldName); //对于table column的fieldName进行处理后返回
			this.stringOrderBy = "";

			/**
			 * 当sortingType为"ascending"时，stringOrderBy将拼接成数据库执行语句 ASC
			 * 当sortingType为"descending"时，stringOrderBy将拼接成数据库执行语句 DESC
			 * 当sortingType为空时，order by 将根据 导师id排序 DESC
			 */
			if (sortingType === "ascending") {
				this.stringOrderBy = StringName + " ASC"; //升序
				this.selectClassInfos();
			} else if (sortingType === "descending") {
				this.stringOrderBy = StringName + " DESC"; //降序
				this.selectClassInfos();
			} else {
				this.stringOrderBy = 25 + " DESC"; //属性排序恢复默认，根据导师id排序
				console.log("排序")
				this.selectClassInfos(); //渲染课节信息
			}
		}

		/**
		 * @description: 导师汇总页面的table中自定义排序方法
		 * @param {any} column 导师汇总中的列信息
		 * @param {any} key 
		 * @param {any} order (升序/排序)
		 * @return void
		 */
		mergeteachersortChange(column: any, key: any, order: any) {
			//获取字段名称和排序类型
			const fieldName = column.column.labelClassName;
			const sortingType = column.order;
			const StringName = this.switchMergeteacherfield(fieldName); //对于table column的fieldName进行处理后返回
			this.StringMergeTeacherOrderBy = "";

			/**
			 * 当sortingType为"ascending"时，stringOrderBy将拼接成数据库执行语句 ASC
			 * 当sortingType为"descending"时，stringOrderBy将拼接成数据库执行语句 DESC
			 * 当sortingType为空时，order by 将根据 导师id排序 DESC
			 */
			if (sortingType === "ascending") {
				this.StringMergeTeacherOrderBy = StringName + " ASC"; //升序
			} else if (sortingType === "descending") {
				this.StringMergeTeacherOrderBy = StringName + " DESC"; //降序
			} else {
				this.StringMergeTeacherOrderBy = "Id"; //默认不排序，但需重新查询
			}
			console.log("排序")
			this.Mergeteacher(); //渲染导师汇总信息
		}

		/**
		 * @description: 学员课程table中自定义排序方法
		 * @param {any} column 学员课程中的列信息
		 * @param {any} key 
		 * @param {any} order (升序/排序)
		 * @return void
		 */
		mergecoursesortChange(column: any, key: any, order: any) {
			//获取字段名称和排序类型
			const fieldName = column.column.labelClassName;
			const sortingType = column.order;
			const StringName = this.switchMergecoursefield(fieldName); //对于table column的fieldName进行处理后返回

			/**
			 * 当sortingType为"ascending"时，stringOrderBy将拼接成数据库执行语句 ASC
			 * 当sortingType为"descending"时，stringOrderBy将拼接成数据库执行语句 DESC
			 * 当sortingType为空时，order by 将根据 导师id排序 DESC
			 */
			if (sortingType === "ascending") {
				this.StringMergeCourseOrderBy = StringName + " ASC"; //升序
			} else if (sortingType === "descending") {
				this.StringMergeCourseOrderBy = StringName + " DESC"; //降序
			} else {
				this.StringMergeCourseOrderBy = "null "; //默认排序
			}
			console.log("排序")
			this.MergeCourse(); //渲染学员课程信息
		}

		/**
		 * @description: 筛选列具体处理操作并关闭筛选列弹窗
		 * @return void
		 */
		dialogVisiblesubmit() {
			this.dialogVisible = false;
			this.renderTablePropertyFields();
		}

		/**
		 * @description: 筛选赠课类型
		 * @return void
		 */
		changeIsFree() {
			//当操作赠送课程后，默认将分页中的"当前页"改为1
			this.queryInfo.pageNum = 1;
			//进入菜单标签后加载相应数据
			this.enterTheLabelMenuToLoadData();
			//加载汇总信息
			// this.TotalSalary();
		}

		/**
		 * @description: 筛选服务状态
		 * @param {boolean} flag
		 * @return void
		 */
		serviceStateChange(flag: boolean) {
			if (flag == false) {
				//触发事件->重新渲染
				this.changeCourse();
			}
		}

		/**
		 * @description: 班主任筛选
		 * @return void
		 */
		changeTeacher() {
			//默认将分页中的"当前页"设置为1
			this.queryInfo.pageNum = 1;
			//进入菜单标签后加载相应数据
			this.enterTheLabelMenuToLoadData();
			//汇总信息  ：计费时长   ：实际时长  ： 薪水
			//this.TotalSalary();
		}

		/**
		 * @description: 学员课程筛选
		 * @return void
		 */
		changeCourse() {
			//默认将分页中的"当前页"设置为1
			this.queryInfo.pageNum = 1; //必须设置，不然Bug
			// if (this.activeIndex === "3") this.MergeCourse();
			// if (this.activeIndex === "1") this.selectClassInfos();
			//汇总信息  ：计费时长   ：实际时长  ： 薪水
			this.TotalSalary();
		}

		/**
		 * @description: 进入菜单tab标签（课节信息，导师汇总，学员课程）后加载相应数据
		 * @return void
		 */
		enterTheLabelMenuToLoadData() {
			//默认将分页中的"当前页"设置为1
			this.queryInfo.pageNum = 1;
			
			//汇总信息  ：计费时长   ：实际时长  ： 薪水
			this.TotalSalary(); // 四合计
		}

		/**
		 * @description: 课节信息中 "基本信息修改"弹窗确认处理方法，对课节信息进行修改
		 * @return void
		 */
		confirmTime() {
			this.$confirm("确认修改此信息吗？", "提示", {
				confirmButtonText: "确定修改",
				cancelButtonText: "我再确认一下",
				type: "success",
			}).then(() => {
				this.editInfoForm.billDuration = Number(this.editInfoForm.billDuration); //强制转换为number
				this.editInfoForm.classRate = Number(this.editInfoForm.classRate); //强制转换为number
				this.editInfoForm.switchValue = this.switchValue; //时区赋值  (PEK , DFW)
				const FastIn =
					this.editInfoForm.classFastln == "" ?
					"" :
					utils.getDetailTime(this.editInfoForm.classFastln, 5); //实际进入
				const LastOut =
					this.editInfoForm.classLastOut == "" ?
					"" :
					utils.getDetailTime(this.editInfoForm.classLastOut, 5); //实际离开
				this.editInfoForm.classFastln =
					typeof FastIn == "undefined" || FastIn == "" ? "" : FastIn;
				this.editInfoForm.classLastOut =
					typeof LastOut == "undefined" || LastOut == "" ? "" : LastOut;
				this.editInfoForm.switchOpenValue = this.switchOpenValue; //公开课类型
				this.editInfoForm.switchFreeValue = this.switchFreeValue; //赠送课类型

				utils
					.requestPost("修改课节基本信息", "classes/updateLeaveTime", this.editInfoForm)
					.then((data: any) => {
						//渲染汇总信息  ：计费时长   ：实际时长  ： 薪水
						this.TotalSalary();
						//渲染课节信息
						// this.selectClassInfos();
						//将修改课节基本信息弹窗关闭
						this.dialogVisible2 = false;

						this.$message({
							showClose: true,
							message: "修改成功！",
							type: "success",
						});
					});
			});
		}

		//监听总课时数据
		@Watch("HoursAndContractForm.totalDuration")
		watchTotalDuration(val: any, oldVal: any): void {
			if (val >= 0) {
				this.totalDurationRadio = "1";
			} else {
				this.totalDurationRadio = "0";
			}
		}
		getContractTime(time){
			if(time.indexOf("0001-01-01") != -1){
				return "";
			}else{
				return utils.getDetailTime(time,4);
			}
		}

		/**
		 * @description: 删除课节信息
		 * @param {any} id 主键
		 * @return void
		 */
		del(id: any) {
			//判断是否时全屏状态下进行删除操作，如果是则退出全屏预览。
			if (document.fullscreenElement) {
				document.exitFullscreen();
			} else if ((document as any).mozCancelFullScreen) {
				(document as any).mozCancelFullScreen();
			} else if ((document as any).webkitExitFullscreen) {
				(document as any).webkitExitFullscreen();
			} else if ((document as any).msExitFullscreen) {
				(document as any).msExitFullscreen();
			}

			//再次确认提示
			this.$confirm("确定删除此课节吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "我再确认一下",
				type: "warning",
			}).then(() => {
				utils
					.requestGet("删除课节信息", "classes/deleteClass", {
						id: id,
					})
					.then((data) => {
						this.$message({
							showClose: true,
							message: "删除成功！",
							type: "success",
						});
						// this.selectClassInfos(); //渲染课节信息数据          
						this.TotalSalary(); //汇总信息  ：计费时长   ：实际时长  ： 薪水
					});
			});
		}

		/**
		 * @description: 对本地localstorage中的筛选列进行赋值到页面中(保留用户上次操作筛选列习惯)
		 * @param {any} str
		 * @param {any} istrue
		 * @return void
		 */
		changeshaixuanlieCol(str: any, istrue: any) {
			for (let i = 0; i < this.shaixuancol.length; i++) {
				if (this.shaixuancol[i].label == str) this.shaixuancol[i].isTrue = istrue;
			}
		}

		/**
		 * @description: 筛选列中，复选框处理事件
		 * @param {any} e
		 * @return void
		 */
		changeCol(e: any) {
			for (let j = 0; j < this.col.length; j++) {
				if (this.shaixuancol[e].label == this.col[j].label) {
					this.col[j].isTrue = !this.shaixuancol[e].isTrue;
				}
			}
			this.shaixuancol[e].isTrue = !this.shaixuancol[e].isTrue; //赋值复选框选择操作状态
			let dropCol = this.dropCol;
			if (this.shaixuancol[e].isTrue == false) {
				dropCol.map((item: any, index: any) => {
					//当为flase为取消选中状态时，该列将删除
					if (item.label == this.shaixuancol[e].label) dropCol.splice(index, 1);
				});
			} else {
				//当为true为选中状态时，该列将自动添加到第一列中
				dropCol.splice(0, 0, this.shaixuancol[e]);
			}

			DataHelperSingleton.getInstance().savaData("dropCol", dropCol); //设置dropCol会打乱
			DataHelperSingleton.getInstance().savaData("detailCol", dropCol); //操作记录至localstorage中

			this.isRouterAlive = false;
			this.$nextTick(() => (this.isRouterAlive = true)); //刷新
			this.renderTablePropertyFields(); //渲染表格属性字段
		}

		/**
		 * @description: 导师汇总中的列拖拽方法
		 * @return void
		 */
		columnDrop1() {
			//查找元素
			const wrapperTr: any = document.querySelector(
				".dragtable1 .el-table__header-wrapper tr"
			);
			this.sortable = Sortable.create(wrapperTr, {
				animation: 180,
				delay: 0,
				onEnd: (evt: any) => {
					const oldItem = this.dropCol1[evt.oldIndex];
					//列拖拽属性操作处理
					this.dropCol1.splice(evt.oldIndex, 1);
					this.dropCol1.splice(evt.newIndex, 0, oldItem);
					//将列拖拽记录至localstorage中
					DataHelperSingleton.getInstance().savaData("detailteachercol", this.dropCol1);
					DataHelperSingleton.getInstance().savaData("dropteacol", this.dropCol1);
				},
			});
		}

		/**
		 * @description: 课节信息中的列拖拽方法
		 * @return void
		 */
		columnDrop() {
			//查找元素
			const wrapperTr: any = document.querySelector(
				".dragtable .el-table__header-wrapper tr"
			);
			this.sortable = Sortable.create(wrapperTr, {
				animation: 180,
				delay: 0,
				onEnd: (evt: any) => {
					const oldItem = this.dropCol[evt.oldIndex];
					//列拖拽属性操作处理
					this.dropCol.splice(evt.oldIndex, 1);
					this.dropCol.splice(evt.newIndex, 0, oldItem);
					//将列拖拽记录至localstorage中
					DataHelperSingleton.getInstance().savaData("detailCol", this.dropCol);
					DataHelperSingleton.getInstance().savaData("dropCol", this.dropCol);
					this.$nextTick(() => {
						this.$refs.multipleTable.doLayout();
					});
				},
			});
		}
		/**
		 * @description: 学员课程中的列拖拽方法
		 * @return void
		 */
		columnDrop2() {
			//查找元素
			const wrapperTr: any = document.querySelector(
				".dragtable2 .el-table__header-wrapper tr"
			);
			this.sortable = Sortable.create(wrapperTr, {
				animation: 180,
				delay: 0,
				onEnd: (evt: any) => {
					const oldItem = this.dropCol2[evt.oldIndex + 1];
					//列拖拽属性操作处理
					this.dropCol2.splice(evt.oldIndex + 1, 1);
					this.dropCol2.splice(evt.newIndex + 1, 0, oldItem);
					//将列拖拽记录至localstorage中
					DataHelperSingleton.getInstance().savaData("detailcourseCol2", this.dropCol2);
					DataHelperSingleton.getInstance().savaData("dropcouCol2", this.dropCol2);
				},
			});
		}

		/**
		 * @description: 消息提示 单元格变色
		 * @param {any} cell 单元格信息
		 * @return void
		 */
		cellStyle(cell: any) {
			//获取单元格信息
			const {
				row,
				column,
				rowIndex,
				columnIndex
			} = cell;
			/**
			 * 合同剩余天数
			          合同结束时间-现在时间(颜色差异需考虑优先级)
			          当day<=10 且 day>0 为橙色
			          当day<=60 且 day>0 为黄色
			          当day>0 为绿色
			          当day<0 为红色
			        平均月预算溢出颜色
			          当百分比>100% 为红色
			          当百分比>75% 为橙色
			          当百分比>50% 为黄色
			          其他为绿色
			 */
			if (column.label == "合同剩余天数") {
				if (row.contractDiffDate <= 10 && row.contractDiffDate > 0) {
					return "background: #E6A23C;padding:0px"; //橙色
				} else if (row.contractDiffDate <= 60 && row.contractDiffDate > 0) {
					return "background: #FFF68F;padding:0px"; //黄色
				} else if (row.contractDiffDate > 0) {
					return "background: #67C23A;color:white;padding:0px"; //绿色
				} else if (row.contractDiffDate < 0) {
					return "background: #FF0000;color:white;padding:0px"; //红色
				}
			}

			//列标签包含"实际平均月消费","平均月预算"处理变色
			if (column.label.includes("实际平均月消费") || column.label.includes("平均月预算")) {
				let judge: any = this.MergeCourseReminders.find((v: any) => {
					return v.id == row.id;
				});
				if (typeof judge != "undefined")
					if (typeof judge != "undefined") {
						if (judge.overflow > 1) {
							return "background: #F56C6C;color:white;padding:0px"; //红色
						} else if (judge.overflow > 0.75) {
							return "background: #E6A23C;color:white;padding:0px"; //橙色
						} else if (judge.overflow > 0.5) {
							return "background: #FFF68F;padding:0px"; //黄色
						}
					}
				return "background: #67C23A;color:white;padding:0px";
			}
		}

		/**
		 * @description: 筛选列中的全选操作
		 * @return void
		 */
		checkAllCol() {
			let dropCol = this.dropCol;

			//将筛选列shaixuancol全部设置为true
			for (var i = this.shaixuancol.length - 1; i >= 0; i--) {
				this.shaixuancol[i].isTrue = true;
				let flag = false;
				for (let j = 0; j < dropCol.length; j++) {
					if (dropCol[j].label == this.shaixuancol[i].label) flag = true;
				}
				if (flag != true) {
					dropCol.splice(0, 0, this.shaixuancol[i]);
				}
			}
			this.col = this.shaixuancol;
			//记录至localstorage中
			DataHelperSingleton.getInstance().savaData("detailCol", dropCol);
			DataHelperSingleton.getInstance().savaData("dropCol", dropCol); //设置dropCol会打乱
			this.renderTablePropertyFields();
		}

		/**
		 * @description: 筛选列中的反选操作
		 * @return void
		 */
		backAllCol() {
			let col: any = [];
			//将筛选列中的istrue反赋值处理
			for (let i = 0; i < this.shaixuancol.length; i++) {
				this.shaixuancol[i].isTrue = !this.shaixuancol[i].isTrue;
				if (this.shaixuancol[i].isTrue == true) {
					col.splice(col.length, 0, this.shaixuancol[i]);
				}
			}
			//记录至localstorage中
			DataHelperSingleton.getInstance().savaData("dropCol", col); //设置dropCol会打乱
			DataHelperSingleton.getInstance().savaData("detailCol", col);
			this.isRouterAlive = false;
			this.$nextTick(() => (this.isRouterAlive = true));
			this.backAllColFlag = true;
			this.renderTablePropertyFields(); //渲染表格属性字段
		}

		/**
		 * @description: 学生邮箱弹窗修改前赋值该学生信息
		 * @return void
		 */
		editEmail(e: any) {
			this.updateEmailDisabled = false;
			const {
				id,
				courseName,
				email
			} = e;
			this.dialog3Form.id = id;
			this.dialog3Form.courseName = courseName;
			this.dialog3Form.email = email;
			this.dialogVisible3 = true;
		}

		/**
		 * @description: 修改该课程中的学生邮箱信息
		 * @return void
		 */
		updateEmail() {
			this.updateEmailDisabled = true;
			//更新学生邮箱
			utils.requestPost("更新课程绑定邮箱", "course/updateEmail", this.dialog3Form).then((data: any) => {
				if (data > 0) {
					this.$message({
						showClose: true,
						message: "修改成功！",
						type: "success",
					});
				} else {
					this.$message({
						showClose: true,
						message: "修改失败",
						type: "info",
					});
				}
				this.updateEmailDisabled = false;
				//关闭窗口
				this.dialogVisible3 = false;
				//渲染数据
				this.MergeCourse();
			});
		}

		// /**
		// * @description: 导师筛选
		// * @return void
		// */
		// selectTeacher() {
		//   //统计导师
		//   let teacherName = [];
		//   let courseName = [];
		//   for (var i = 0; i < this.list.length; i++) {
		//     if (JSON.stringify(teacherName).indexOf(this.list[i].tid.teacherName) == -1) {
		//       teacherName.push(this.list[i].tid.teacherName);
		//     }
		//     if (JSON.stringify(courseName).indexOf(this.list[i].coid.courseName) == -1) {
		//       courseName.push(this.list[i].coid.courseName);
		//     }
		//   }
		//   this.teacherName = teacherName;
		//   this.courseName = courseName;
		// }

		/**
		 * @description: 下拉菜单选择 查询教师信息
		 * @return void
		 */
		selectTeacherOptions() {
			this.teacherName = [];
			utils
				.requestPost("筛选导师信息", "teacher/search", {
					searchSelectDate: {
						classStartName: this.valueTime != null && this.valueTime.length > 0 ?
							this.valueTime[0] : "",
						classEndName: this.valueTime != null && this.valueTime.length > 0 ?
							this.valueTime[1] : "",
						switchDate: this.switchValue,
					},
					page: {
						pageNum: this.queryInfo.pageNum,
						pageSize: this.queryInfo.pageSize,
					},
					stringOrderBy: this.stringOrderBy,
					teacherName: this.value,
					courseName: String(this.coursevalue),
					headmaster: String(this.headMasterValue),
					isFree: String(this.isFreeValue),
					isPublic: Boolean(this.openClassFlag),
					serviceState: String(this.serviceState),
					email: utils.getAccountEmail(),
					name: utils.getAccountName(),
				})
				.then((data: any) => {
					this.teacherName = Object.assign({}, data);
				});
		}

		/**
		 * @description: 下拉菜单选择 查询班主任信息
		 * @return void
		 */
		selectHeadMasterOptions() {
			this.headMaster = [];
			utils
				.requestPost("筛选班主任信息", "students/search", {
					searchSelectDate: {
						classStartName: this.valueTime != null && this.valueTime.length > 0 ?
							this.valueTime[0] : "",
						classEndName: this.valueTime != null && this.valueTime.length > 0 ?
							this.valueTime[1] : "",
						switchDate: this.switchValue,
					},
					page: {
						pageNum: this.queryInfo.pageNum,
						pageSize: this.queryInfo.pageSize,
					},
					stringOrderBy: this.stringOrderBy,
					teacherName: this.value,
					courseName: String(this.coursevalue),
					headmaster: String(this.headMasterValue),
					isFree: String(this.isFreeValue),
					isPublic: Boolean(this.openClassFlag),
					serviceState: String(this.serviceState),
					email: utils.getAccountEmail(),
					name: utils.getAccountName(),
				})
				.then((data: any) => {
					this.headMaster = Object.assign({}, data);
				});
		}

		/**
		 * @description: 下拉菜单选择 筛选学员课程信息
		 * @return void
		 */
		selectCourseNameOptions() {
			this.courseName = [];
			utils
				.requestPost("筛选学员课程信息", "course/search", {
					searchSelectDate: {
						classStartName: this.valueTime != null && this.valueTime.length > 0 ?
							this.valueTime[0] : "",
						classEndName: this.valueTime != null && this.valueTime.length > 0 ?
							this.valueTime[1] : "",
						switchDate: this.switchValue,
					},
					page: {
						pageNum: this.queryInfo.pageNum,
						pageSize: this.queryInfo.pageSize,
					},
					stringOrderBy: this.stringOrderBy,
					teacherName: this.value,
					courseName: String(this.coursevalue),
					headmaster: String(this.headMasterValue),
					isFree: String(this.isFreeValue),
					isPublic: Boolean(this.openClassFlag),
					serviceState: String(this.serviceState),
					email: utils.getAccountEmail(),
					name: utils.getAccountName(),
				})
				.then((data: any) => {
					let courseName = [];
					for (let i = 0; i < data.length; i++) {
						courseName.push({
							value: data[i].id,
							label: data[i].courseName
						});
					}
					this.courseName = courseName;
				});
		}

		/**
		 * @description: 下拉菜单选择 服务状态
		 * @return void
		 */
		selectServiceStateOptions() {
			utils.requestGet("查询服务状态和其他费用可用类型", "ServiceState/QueryServiceStatusOptions", null).then((data: any) => {
				this.serviceStateOptionsEdit = this.serviceStateOptions = data.states;
			});
		}

		/**
		 * @description: 渲染表格属性字段 (如果localstorage中存在列表记录，则使用，否则根据store中列排序规则)
		 * @return void
		 */
		renderTablePropertyFields() {
			this.columnDrop(); // 课节信息 表列拖拽
			this.columnDrop1(); // 导师汇总 表列拖拽
			this.columnDrop2(); // 学员课程 表列拖拽

			var col = this.$store.state.col; //将store的课节信息表属性字段赋值

			this.shaixuancol = col; //筛选列渲染

			//判断localstorage中detailcol是否存在,存在则根据store中列排序规则
			//不存在时
			if (
				DataHelperSingleton.getInstance().readData("detailCol").length == 0 &&
				this.backAllColFlag == false
			) {
				DataHelperSingleton.getInstance().savaData("detailCol", col);
				DataHelperSingleton.getInstance().savaData("dropCol", col);
			} else {
				//存在，读取localstorage数据
				this.col = DataHelperSingleton.getInstance().readData("detailCol");

				for (var i = 0; i < this.shaixuancol.length; i++) {
					this.shaixuancol[i].isTrue = false;
				}

				for (var i = 0; i < this.col.length; i++) {
					this.changeshaixuanlieCol(this.col[i].label, true);
				}

				this.dropCol = DataHelperSingleton.getInstance().readData("dropCol");
			}

			if (
				DataHelperSingleton.getInstance().readData("detailteachercol").length == 0 &&
				this.backAllColFlag == false
			) {
				DataHelperSingleton.getInstance().savaData("detailteachercol", this.Col1);
				DataHelperSingleton.getInstance().savaData("dropteacol", this.dropCol1);
			} else {
				this.Col1 = DataHelperSingleton.getInstance().readData("detailteachercol");
				this.dropCol1 = DataHelperSingleton.getInstance().readData("dropteacol");
			}
			if (
				DataHelperSingleton.getInstance().readData("dropcouCol2").length == 0 &&
				this.backAllColFlag == false
			) {
				DataHelperSingleton.getInstance().savaData("dropcouCol2", this.Col2);
				DataHelperSingleton.getInstance().savaData("dropcouCol2", this.dropCol2);
			} else {
				this.Col2 = DataHelperSingleton.getInstance().readData("dropcouCol2");
				this.dropCol2 = DataHelperSingleton.getInstance().readData("dropcouCol2");
			}
		}

		/**
		 * @description: 浏览学员课程信息
		 * @return void
		 */
		MergeCourse() {
			/**
			 * <summary>
			 * 当第一次初始页面载入时，需要判断服务状态是否加载
			 * </summary>
			 * <params>null</params>
			 * <returns>
			 * 服务状态下拉菜单
			 * </returns>
			 * <returnsType>
			 *  Array<{value:number,label:string}}>
			 * </returnsType>
			 */
			if (this.$refs['selectsServiceState'].emptyText != null) {
				this.selectServiceStateOptions();
			}

			//查询学员课程信息
			utils
				.requestPost("查询学员课程", "course/MergeCourse", {
					searchSelectDate: {
						classStartName: this.valueTime != null && this.valueTime.length > 0 ?
							this.valueTime[0] : "",
						classEndName: this.valueTime != null && this.valueTime.length > 0 ?
							this.valueTime[1] : "",
						switchDate: this.switchValue,
					},
					page: {
						pageNum: this.queryInfo.pageNum,
						pageSize: this.queryInfo.pageSize,
					},
					stringOrderBy: this.StringMergeCourseOrderBy,
					teacherName: this.value,
					courseName: String(this.coursevalue),
					headmaster: String(this.headMasterValue),
					isFree: String(this.isFreeValue),
					isPublic: Boolean(this.openClassFlag),
					serviceState: String(this.serviceState),
					email: utils.getAccountEmail(),
					name: utils.getAccountName(),
				})
				.then((data: any) => {
					this.teacherName = data.teachers;
					this.headMaster = data.headMasters;
					let courseName = [];
					for (let i = 0; i < data.students.length; i++) {
						courseName.push({
							value: data.students[i].id,
							label: data.students[i].courseName
						});
					}
					this.courseName = courseName;

					let courseList = [];
					for (let i = 0; i < data.studentInfo.mergeCourse.length; i++) {
						let studentHeadmaster = "";
						courseList.push({
							id: data.studentInfo.mergeCourse[i].id,
							courseName: data.studentInfo.mergeCourse[i].courseName,
							times: Number(data.studentInfo.mergeCourse[i].actualDuration).toFixed(2),
							studentHeadmaster: data.studentInfo.mergeCourse[i].studentHeadmaster,
							billDuration: Number(data.studentInfo.mergeCourse[i].billDuration).toFixed(2),
							email: data.studentInfo.mergeCourse[i].email,
							serviceStateName: data.studentInfo.mergeCourse[i].serviceStateName,
							contractStartTime: data.studentInfo.mergeCourse[i].contractStartTime,
							contractEndTime: data.studentInfo.mergeCourse[i].contractEndTime,
							contractDiffDate: data.studentInfo.mergeCourse[i].contractDiffDate,
							averageMonthlyBudget: "￥ " + data.studentInfo.mergeCourse[i].averageMonthlyBudget,
							averageMonthlyBudgetUSD: "$ " + data.studentInfo.mergeCourse[i]
								.averageMonthlyBudgetUSD,
							actualAverageMonthlyCost: "￥ " + data.studentInfo.mergeCourse[i]
								.actualAverageMonthlyCost,
							actualAverageMonthlyCostUSD: "$ " + data.studentInfo.mergeCourse[i]
								.actualAverageMonthlyCostUSD,
							sumUSD: "$ " + Number(data.studentInfo.mergeCourse[i].salaryUSD).toFixed(2),
							sumCNY: "￥ " + Number(data.studentInfo.mergeCourse[i].salaryCNY).toFixed(2),
							totalDuration: utils.convertHours(data.studentInfo.mergeCourse[i].totalDuration),							leftDuration: utils.convertHours(data.studentInfo.mergeCourse[i].leftDuration),

							remainingbudgetUSD: "$ " + data.studentInfo.mergeCourse[i].remainingbudgetUSD,
							remainingbudgetCNY: "￥ " + data.studentInfo.mergeCourse[i].remainingbudgetCNY,

							remainingbudgetPercentages: data.studentInfo.mergeCourse[i].remainingbudgetPercentages == 99999? "-∞ %" : data.studentInfo.mergeCourse[i].remainingbudgetPercentages + "%",
							cnyMoney: "￥ " + data.studentInfo.mergeCourse[i].cnyMoney,
							usdMoney: "$ " + data.studentInfo.mergeCourse[i].usdMoney,
							
							state: data.studentInfo.mergeCourse[i].state == 0 ? '历史信息':data.studentInfo.mergeCourse[i].state == 1 ? '进行中':data.studentInfo.mergeCourse[i].state == 2?'已结束':'',
							ifRate: data.studentInfo.mergeCourse[i].ifRate == 1 ? '未评价':(data.studentInfo.mergeCourse[i].avgRate.toFixed(2)),
							minRate: data.studentInfo.mergeCourse[i].minRate,
							overflow: data.studentInfo.mergeCourse[i].overflow,
							score: data.studentInfo.mergeCourse[i].score,
							courseEndTime: data.studentInfo.mergeCourse[i].courseEndTime,
							submissionTime: data.studentInfo.mergeCourse[i].submissionTime,
						});
					}
					//分页总条数
					this.total = data.studentInfo.total;
					//学员课节中 合同剩余天数以及平均月预算和实际平均月预算颜色提示
					//this.MergeCourseReminders = data.studentInfo.reminder;
					//学员课节信息
					this.courseList = courseList;
				});
		}

		/**
		 * @description: 浏览导师汇总信息
		 * @return void
		 */
		Mergeteacher() {
			utils.getUSDExchangeRate().then((rate: any) => {
				utils
					.requestPost("查询导师汇总", "teacher/Mergeteacher", {
						searchSelectDate: {
							classStartName: this.valueTime != null && this.valueTime.length > 0 ?
								this.valueTime[0] : "",
							classEndName: this.valueTime != null && this.valueTime.length > 0 ?
								this.valueTime[1] : "",
							switchDate: this.switchValue,
						},
						page: {
							pageNum: this.queryInfo.pageNum,
							pageSize: this.queryInfo.pageSize,
						},
						stringOrderBy: this.StringMergeTeacherOrderBy,
						teacherName: this.value,
						courseName: String(this.coursevalue),
						headmaster: String(this.headMasterValue),
						rate: rate,
						isPublic: Boolean(this.openClassFlag),
					})
					.then((data: any) => {
						this.teacherName = data.teachers;
						this.headMaster = data.headMasters;
						let teacherList = [];
						for (var i = 0; i < data.mergeTeacher.mergeTeacher.length; i++) {
							teacherList.push({
								teacherName: data.mergeTeacher.mergeTeacher[i].teacherName,
								types: data.mergeTeacher.mergeTeacher[i].types,
								times: Number(data.mergeTeacher.mergeTeacher[i].classActualDuration)
									.toFixed(2),
								price: data.mergeTeacher.mergeTeacher[i].teacherRate,
								payrateUSD: "$" +
									Number(
										data.mergeTeacher.mergeTeacher[i].salaryUSD
									).toFixed(2),
								payrateCNY: "￥" +
									Number(
										data.mergeTeacher.mergeTeacher[i].salaryCNY
									).toFixed(2),
								xinxi: data.mergeTeacher.mergeTeacher[i].userInformation,
								fukuanfangshi: data.mergeTeacher.mergeTeacher[i].teacherPay,
								name: data.mergeTeacher.mergeTeacher[i].userName,
								billDuration: data.mergeTeacher.mergeTeacher[i].billDuration,
								identity: data.mergeTeacher.mergeTeacher[i].identity,
								phone: data.mergeTeacher.mergeTeacher[i].phone
							});
						}
						//导师汇总信息
						this.teacherList = teacherList;
						//导师总条数
						this.total = data.mergeTeacher.total;
					});
			});
		}

		/**
		 * @description: 浏览主页课节信息
		 * @return void
		 */
		selectClassInfos() {
			//查询信息
			utils.requestPost("查询主页课节信息", "infos/select", {
					searchSelectDate: {
						classStartName: this.valueTime != null && this.valueTime.length > 0 ?
							this.valueTime[0] : "",
						classEndName: this.valueTime != null && this.valueTime.length > 0 ?
							this.valueTime[1] : "",
						switchDate: this.switchValue,
					},
					page: {
						pageNum: this.queryInfo.pageNum,
						pageSize: this.queryInfo.pageSize,
					},
					stringOrderBy: this.stringOrderBy,
					teacherName: this.value,
					courseName: String(this.coursevalue),
					headmaster: String(this.headMasterValue),
					isFree: String(this.isFreeValue),
					isPublic: Boolean(this.openClassFlag),
					serviceState: String(this.serviceState),
					email: utils.getAccountEmail(),
					name: utils.getAccountName(),
				})
				.then((data: any) => {
					this.teacherName = data.teachers;
					this.headMaster = data.headMasters;
					let courseName = [];
					for (let i = 0; i < data.students.length; i++) {
						courseName.push({
							value: data.students[i].id,
							label: data.students[i].courseName
						});
					}
					this.courseName = courseName;
					this.total = data.classInfos.total > 0 ? data.classInfos.total : 0;
					const dataList = data.classInfos.data;
					for (let i = 0; i < dataList.length; i++) {
						try{
							dataList[i].cid.salaryUSD = "$"+parseFloat(dataList[i].cid.salaryUSD).toFixed(2);
							dataList[i].cid.salaryCNY = "￥"+parseFloat(dataList[i].cid.salaryCNY).toFixed(2);
						}catch(e){
							
						}
						
						if (dataList[i].coid.totalDuration == -1) {
							dataList[i].coid.totalDuration = "+ ∞";
							dataList[i].coid.leftDuration = "+ ∞";
						}
						//当为公开课时，服务状态设置为空
						if (dataList[i].cid.isPublic == true) {
							dataList[i].serviceState.serviceStateName = "";
						}
					}

					//课节信息
					this.list = dataList;
					//刷新
					this.$refs.multipleTable.doLayout();
				});
		}

		/**
		 * @description: 汇总信息  ：计费时长   ：实际时长  ： 薪水
		 * @return void
		 */
		TotalSalary() {
			console.log("查询薪水")
			if (this.activeIndex === "1") {
				this.selectClassInfos(); //当活动索引为1时，渲染课节信息
			}
			if (this.activeIndex === "2") {
				this.Mergeteacher(); //当活动索引为2时，渲染导师汇总信息
			}
			if (this.activeIndex === "3") {
				this.MergeCourse(); //当活动索引为3时，渲染学员课程信息
			}
			let value = this.value;
			let coursevalue = String(this.coursevalue);
			let headMasterValue = String(this.headMasterValue);
			//对应 标签菜单 搜索   （清空其他标签的值）
			if (this.activeIndex === "1") {}
			if (this.activeIndex === "2") {
				coursevalue = "";
			}
			if (this.activeIndex === "3") {
				value = "";
			}

			//浏览 计费时长   ：实际时长  ： 薪水
			utils
				.requestPost("查询教师TotalSalary", "teacher/TotalSalary", {
					searchSelectDate: {
						classStartName: String(
							this.valueTime != null ?
							this.valueTime.length > 1 ?
							this.valueTime[0] :
							"2000-01-01" :
							"2000-01-01"
						),
						classEndName: String(
							this.valueTime != null ?
							this.valueTime.length > 1 ?
							this.valueTime[1] :
							"3000-01-01" :
							"3000-01-01"
						),
						switchDate: this.switchValue, //PEK DFW切换
					},
					page: {
						pageNum: this.queryInfo.pageNum,
						pageSize: this.queryInfo.pageSize,
					},
					stringOrderBy: this.StringMergeCourseOrderBy,
					teacherName: value,
					courseName: coursevalue,
					headmaster: headMasterValue,
					isFree: String(this.isFreeValue),
					isPublic: this.openClassFlag,
					serviceState: String(this.serviceState),
					email: utils.getAccountEmail(),
					name: utils.getAccountName(),
					tab: this.activeIndex,
				})
				.then((data: any) => {
					this.billDuration = Number(data.billDuration).toFixed(2);
					this.actualDuration = Number(data.classActualDuration).toFixed(2);
					this.sumvalueUSD = Number(data.salaryUSD).toFixed(2);
					this.sumvalueCNY = Number(data.salaryCNY).toFixed(2);
					this.sumScore = Number(data.score);
				});
		}

		/**
		 * @description: 生命周期 mounted挂载后
		 * @return void
		 */
		mounted() {
			//窗口尺寸
			window.onresize = () => {
				this.tabelHeight = window.innerHeight;
			};

			//加载时跳转到相应菜单
			if (localStorage.getItem("WelcomeIndex") == undefined) {
				localStorage.setItem("WelcomeIndex", "1");
			}
			//在localstorage中查找上一次用户tab标签 :课节信息，导师汇总和学员课程
			this.activeIndex = localStorage.getItem("WelcomeIndex");


			this.enterTheLabelMenuToLoadData(); //进入菜单标签后加载相应数据

			this.selectServiceStateOptions(); //下拉菜单选择 服务状态

			this.renderTablePropertyFields(); //渲染表格属性字段
		}

		created() {
			this.$store.commit("loadingInformation", 0);
		}
	}
